import React from "react";
import { FormHelperText } from "@material-ui/core";
import { Field, useFormikContext } from "formik";

const IssueCopyNauticalCheckboxes = ({ disableAll }) => {
  const { errors, touched } = useFormikContext();

  const tableWithLabels = [
    {
      value: "1",
      label:
        "1. Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην έκδοση αντιγράφου ναυτικού φυλλαδίου λόγω κλοπής - απώλειας.",
    },
    {
      value: "2",
      label:
        "2.Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην έκδοση αντιγράφου ναυτικού φυλλαδίου λόγω συμπλήρωσης ή φθοράς.",
    },
    {
      value: "3",
      label:
        "3.Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην έκδοση αντιγράφου ναυτικού φυλλαδίου λόγω αλλαγής ναυτικού φυλλαδίου από περιορισμένης χρήσης σε όλους τους κλάδους και αντίθετα.",
    },
  ];

  return (
    <div>
      <p className="underline text-base font-bold">
        ΑΙΤΗΣΗ ΕΚΔΟΣΗΣ ΑΝΤΙΓΡΑΦΟΥ Ν.Φ.
      </p>
      <br></br>

      <div
        className="flex flex-col"
        role="group"
        aria-labelledby="my-radio-group"
      >
        {errors["reason_for_copy_nautical_issue"] &&
          touched["reason_for_copy_nautical_issue"] && (
            <FormHelperText className="text-xl text-error border-l-2 border-error pl-1">
              Επιλέξτε μία από τις τρεις επιλογές
            </FormHelperText>
          )}
        {tableWithLabels.map((item) => {
          return (
            <label key={item.value} className="p-2 flex">
              <Field
                type="radio"
                name="reason_for_copy_nautical_issue"
                value={item.value}
                disabled={disableAll}
              />
              <p className="ml-1 font-bold">{item.label}</p>
            </label>
          );
        })}
      </div>
      <br></br>
    </div>
  );
};

export default IssueCopyNauticalCheckboxes;
